module.exports = __webpack_public_path__ + "components/MapControl/svg/Przystanek tramwajowy.svg?4f8b58c1";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Przystanek tramwajowy.svg
// module id = 2090
// module chunks = 0